export default "__VITE_ASSET__Bd_qEMfF__"